import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { ugcCommentShape, catalogBibShape } from '@bibliocommons/bc-prop-types';
import { ExpandableText } from '@bibliocommons/expandable';
import UgcList from 'app/components/bibs/shared/ugc/UgcList';
import CommentDisplayContainer from 'app/components/bibs/shared/ugc/CommentDisplay';
import './StaffComments.scss';

export default class StaffComments extends React.PureComponent {
  handleDeleteSuccess = () => {
    const metadataId = this.props.catalogBib.get('metadataId');
    this.props.bibsActions.fetchUGC(metadataId);
  };

  renderComment = comment => {
    return (
      <CommentDisplayContainer
        comment={comment}
        displayStaffBadge={false}
        catalogBib={this.props.catalogBib}
        handleDeleteSuccess={this.handleDeleteSuccess}
      >
        <ExpandableText
          text={comment.get('comment')}
          truncateCount={240}
          expandLinkHref={`#read-more-ugc-display-${comment.get('id')}`}
          textKey="comment"
        />
      </CommentDisplayContainer>
    );
  };

  render() {
    return (
      this.props.comments.size > 0 && (
        <section className="cp-staff-comments">
          <h3 className="staff-comments-subtitle">
            <FormattedMessage id="staff_comments_section" />
          </h3>
          <UgcList
            items={this.props.comments}
            catalogBib={this.props.catalogBib}
            transactions={this.props.commentsTransactions}
            renderItem={this.renderComment}
            contentType="staff_comments"
          />
        </section>
      )
    );
  }
}

StaffComments.propTypes = {
  comments: ImmutablePropTypes.listOf(ugcCommentShape),
  commentsTransactions: ImmutablePropTypes.map.isRequired,
  catalogBib: catalogBibShape.isRequired,
  bibsActions: PropTypes.objectOf(PropTypes.func).isRequired
};
